import { useState, useEffect } from "react";
import styles from "../maintenancerequestdetails.module.css";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { FormControl, InputLabel, MenuItem, ListSubheader, Select, Autocomplete, TextField, createFilterOptions, FormControlLabel, Checkbox } from "@mui/material";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const schema = yup.object().shape({
  tenant_id: yup.string().required("This field is Required"),
  category: yup.string().required("This field is Required"),
  priority: yup.string().required("This field is Required"),
  terms: yup.boolean().when("category", (category) => {
    if (category && category === "Mount Television")
      return yup.boolean().oneOf([true], "Please accept terms to proceed.");
    else
      return yup.boolean();
  }),
});

const categoryGroupOptions = [
  { label: "Electrical", parent: 1 },
  { value: "Mount Television", label: "Mount Television", parent: 0, category: "Electrical", img_path: "/static/img/tv.svg" },
  { value: "Electrical Socket", label: "Electrical Socket", parent: 0, category: "Electrical", img_path: "/static/img/ElectricalSocket.svg" },
  { value: "Light Switch/Dimmer", label: "Light Switch/Dimmer", parent: 0, category: "Electrical", img_path: "/static/img/Dimmer.svg" },
  { label: "Plumbing", parent: 1 },
  { value: "Leak", label: "Leak", parent: 0, category: "Plumbing", img_path: "/static/img/Leak.svg" },
  { value: "Drain Clogged", label: "Drain Clogged", parent: 0, category: "Plumbing", img_path: "/static/img/DrainClogged.svg" },
  { value: "Water Temperature Issue", label: "Water Temperature Issue", parent: 0, category: "Plumbing", img_path: "/static/img/WaterTemperature.svg" },
  { value: "Heating & Cooling System", label: "Heating & Cooling System", parent: 0, category: "Plumbing", img_path: "/static/img/heat&cool.svg" },
  { label: "Appliances", parent: 1 },
  { value: "Stove/Oven Issue", label: "Stove/Oven Issue", parent: 0, category: "Appliances", img_path: "/static/img/StoveOven.svg" },
  { value: "Refrigerator Issue", label: "Refrigerator Issue", parent: 0, category: "Appliances", img_path: "/static/img/Refrigerator.svg" },
  { value: "Washer/Dryer Issue", label: "Washer/Dryer Issue", parent: 0, category: "Appliances", img_path: "/static/img/Washer.svg" },
  { label: "Smart Devices", parent: 1 },
  { value: "Door Lock", label: "Door Lock", parent: 0, category: "Smart Devices", img_path: "/static/img/Door.svg" },
  { value: "Dimmer", label: "Dimmer", parent: 0, category: "Smart Devices", img_path: "/static/img/bulb.svg" },
  { value: "Thermostat", label: "Thermostat", parent: 0, category: "Smart Devices", img_path: "/static/img/temperature.svg" },
  { label: "Other", parent: 1 },
  { value: "Other Issue", label: "Other Issue", parent: 0, category: "Other", img_path: "/static/img/other.svg" },
];

const EditMaintenanceForm = ({ setAddModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, setRequestData, requestData }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [tenantList, setTenantList] = useState([]);
  const [tenantList2, setTenantList2] = useState([]);
  const [isMountTVCat, setIsMountTVCat] = useState(false);

  const { handleSubmit, control, setValue, clearErrors, errors } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      tenant_id: "",
      category: "",
      priority: "",
      terms: false
    }
  });

  useEffect(() => {
    if (requestData) {
      setValue('tenant_id', requestData?.tenant_id);
      setValue('category', requestData?.sub_category);
      setValue('priority', requestData?.priority);
      if (requestData?.sub_category === 'Mount Television') {
        setIsMountTVCat(true);
      }
    }
  }, [requestData, setValue]);

  useEffect(() => {
    async function fetchTenants() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios.get(process.env.REACT_APP_CASE_API_URL + "v1/property-tenant-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        let tFinalList = [];
        let tFinalList2 = [];

        let templistNew = response.data.data;

        templistNew?.map((item) => {
          tFinalList.push({ label: item.label, parent: 1 });
          item?.options?.map((subItem) => {
            tFinalList.push({
              value: subItem.value,
              label: subItem.label,
              parent: 0,
              propertyId: item?.id,
            });
            return false;
          });

          return false;
        });

        templistNew?.map((item) => {
          item?.options?.map((subItem) => {
            tFinalList2.push({
              group: item?.label,
              value: subItem?.value,
              label: subItem.label
            });
            return false;
          });

          return false;
        });

        setTenantList(tFinalList);
        setTenantList2(tFinalList2);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
    }

    fetchTenants();
  }, [getAccessTokenSilently]);

  const onSubmit = async (data) => {
    let postData = {};

    postData = { ...postData, tenant_id: data?.tenant_id, priority: data?.priority, description: data?.description };
    if (data?.tenant_id) {
      let selectTenant = tenantList?.filter((i) => i?.value === parseInt(data?.tenant_id));
      postData = { ...postData, property_id: selectTenant[0]?.propertyId };
    }
    if (data?.category) {
      let selectCat = categoryGroupOptions?.filter((i) => i?.value === data.category);
      postData = { ...postData, category: selectCat[0]?.category, sub_category: data?.category };
    }

    setLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.post(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setAddModalOpen(false);

      setRequestData(prev => {
        return { ...prev, ...response.data.data };
      });

      let logData = {
        title: "A maintenance request has been updated",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const filterOptions = createFilterOptions({
    matchFrom: 'any'
  });

  return (<div className={`${styles.ProfileCardEditSec}`}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          {/* <label className={`${styles.FilterLabel}`}>Tenant Selection</label> */}
          <FormControl fullWidth>
            <Controller
              name="tenant_id"
              control={control}
              render={(field) => (<Autocomplete
                value={field?.value ? tenantList2?.filter(i => i?.value === field?.value)[0] : null}
                filterOptions={filterOptions}
                options={tenantList2.sort((a, b) => -b.group.localeCompare(a.group))}
                groupBy={(option) => option.group}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (<TextField {...params} label="Select Tenant*" />)}
                onChange={(event, newValue) => {
                  setValue('tenant_id', newValue?.value);
                  clearErrors();
                }}
              />)}
            />
          </FormControl>
        </div>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          {/* <label className={`${styles.FilterLabel}`}>Category Selection</label> */}
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Category*</InputLabel>
            <Controller
              name="category"
              control={control}
              render={(field) => (
                <Select
                  label="Select Category*"
                  {...field}
                  onChange={(e) => {
                    field.onChange(e);
                    if (e.target.value === 'Mount Television') {
                      setIsMountTVCat(true);
                    } else {
                      setIsMountTVCat(false);
                    }
                  }}
                >
                  {categoryGroupOptions.map((item) => {
                    if (item?.parent === 1)
                      return (<ListSubheader className={`${styles.GropSelectTitle}`}>{item?.label}</ListSubheader>);
                    else
                      return (<MenuItem value={item?.value} className={`${styles.GropSelectList}`}>
                        <img src={item?.img_path} alt="" />
                        {item?.label}
                      </MenuItem>);
                  })}
                </Select>
              )}
            />
          </FormControl>
        </div>
        <div className={`${styles.FormGroupFull}`}>
          <div className={`${styles.FormGroupHalf} FormGroup`}>
            {/* <label className={`${styles.FilterLabel}`}>Priority Level</label> */}
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Importance*</InputLabel>
              <Controller
                name="priority"
                control={control}
                render={(field) => (
                  <Select
                    label="Importance*"
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                    }}
                  >
                    <MenuItem value={1}>Low</MenuItem>
                    <MenuItem value={2}>Medium</MenuItem>
                    <MenuItem value={3}>High</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </div>
        </div>
      </LocalizationProvider>
      {isMountTVCat && <>
        <div className={`${styles.DisclaimerText}`}>
          <p><span>TV Mount Waiver Agreement</span><br />We recommend that the tenant be present in their unit during the TV mounting appointment to ensure the installation proceeds smoothly. Please be advised that the property management team and its contractors are <span>not liable for any damage to the TV or related equipment during or after installation.</span></p>
          <p>If adjustments or re-mounting are requested after the initial installation, a <span>$100 service fee</span> will apply. <br />By submitting this maintenance request, you acknowledge and agree to the terms of this waiver.</p>
          <p>Additionally, if the appointment cannot be completed for any reason such as missing parts, incorrect mounting instructions, or other issues that prevent installation, a <span>$100 service fee</span> will be required to reschedule the appointment.</p>
          <p>By submitting this maintenance request, you acknowledge that you have read and agree to these terms.</p>
          <FormControlLabel className="FormCheckbox"
            control={<Controller
              name="terms"
              control={control}
              render={(props) => <Checkbox
                {...props}
                onChange={(e) => {
                  props.onChange(e);
                  setValue('terms', e.target.checked);
                }}
                checked={props?.value ? true : false}
              />}
            />}
            label="I have read and agree to the terms of the TV Mount Waiver Agreement."
          />
          {errors.terms && (<p className={`${styles.ErrorM}`}>{errors.terms.message}</p>)}
        </div>
      </>}
      <div className={`${styles.ButtonArea}`}>
        <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => setAddModalOpen(false)}>Cancel</button>
        <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
      </div>
    </form>
  </div>);
};

export default EditMaintenanceForm;